console.log("CR Script is running...");

var isCustomizeButtonClicked = false; // Flag to track if the customize button was clicked

CANDYRACK_DOCUMENT_LISTENER = false;
CANDYRACK_CUSTOM_BUTTON_SELECTORS = [
  ".product-form__submit",
  "form[id^='product-form'] .pplr_atc_form"
];

// Initialize MutationObserver
function observePATCClassRemoval() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.target.classList.contains("p_a_t_c")) {
        console.log("Removing 'p_a_t_c' class from a product form button due to mutation...");
        mutation.target.classList.remove("p_a_t_c");
      }
    });
  });

  const targetElements = document.querySelectorAll("form[id^='product-form'] .product-form__submit");
  targetElements.forEach((target) => {
    observer.observe(target, { attributes: true, attributeFilter: ["class"] });
  });
}

// Polling method to check on slow loads
const crInterval = setInterval(() => {
  const crB2 = document.querySelectorAll(".product-form__submit.p_a_t_c");
  if (crB2.length) {
    crB2.forEach(cr => cr.classList.remove("p_a_t_c"));
    clearInterval(crInterval);
  }
}, 100);

// Call the observer function
observePATCClassRemoval();

CANDYRACK_CAN_ATC = () => {
  const requiredFields = Array.from(document.querySelectorAll('.pplr-wrapper input[required]'))
    .filter(field => getComputedStyle(field.closest('.pplr-wrapper')).display !== 'none');

  const selectToCustomizeExists = !!document.querySelector('input[name^="Select To Customize-1"]');
  const selectedOption = document.querySelector('input[name^="Select To Customize-1"]:checked');

  if (selectToCustomizeExists && !selectedOption) {
    console.log("No selected option found for 'Select To Customize-1'");
  }

  const allFieldsFilled = requiredFields.every(field => {
    const fieldValue = field.value.trim();
    if (!fieldValue) {
      console.log(`Missing value in field: ${field.name || field.id || 'unknown field'}`);
    }
    return !!fieldValue;
  });

  if (!allFieldsFilled) {
    console.log("Some required fields are missing.");
  }

  console.log(`Number of visible required fields: ${requiredFields.length}`);

  // return allFieldsFilled && (!selectToCustomizeExists || selectedOption);
  return canAddToCart();

  function canAddToCart() {
    if (!allFieldsFilled) {
      return false;
    }

    if (!selectToCustomizeExists) {
      return true;
    }

    if (selectedOption) {
      return true;
    }

    return true; // default
  }
};

function htmlToElement(html) {
  var template = document.createElement("template");
  html = html.trim();
  template.innerHTML = html;
  return template.content.firstChild;
}

function waitForProductAddedAndRedirect(redirectURL) {
  return new Promise((resolve) => {
    const checkCompletionInterval = setInterval(() => {
      const itemAddedElement = document.querySelector(".pplr-item-added");
      if (itemAddedElement && getComputedStyle(itemAddedElement).display !== "none") {
        clearInterval(checkCompletionInterval);
        setTimeout(() => resolve(), 500); // Ensure product is added before resolving
      }
    }, 500);
  }).then(() => {
    console.log(`Redirecting to: ${redirectURL}`);
    window.location.href = redirectURL;
  });
}

document.addEventListener("addToCartButtonClicked", () => {
  console.log("addToCartButtonClicked event triggered");

  // Check if the current page is /products/mini-bag-tag
  if (window.location.pathname === "/products/mini-bag-tag") {
    console.log("Mini Bag Tag detected - redirecting to cart after adding to cart");
    waitForProductAddedAndRedirect('https://visitag.com/cart');
    return; // Exit the event listener to skip upsell logic
  }

  const upsellData = [
    {
      offerId: "208625",
      buttonId: "cr-cust-link-6",
      //redirectLink: "/products/mini-bag-tag"
      redirectLink: "/discount/CANDYRACK-2507MQJY3P?redirect=/products/mini-bag-tag"
    },
    {
      offerId: "208624",
      buttonId: "cr-cust-link-5",
      //redirectLink: "/products/mini-keychain"
      redirectLink: "/discount/CANDYRACK-57081JZKO1?redirect=/products/mini-keychain"
    },
    {
      offerId: "208623",
      buttonId: "cr-cust-link-4",
      //redirectLink: "/products/keychain"
      redirectLink: "/discount/CANDYRACK-GMOG2EM2OW?redirect=/products/keychain"
    }
  ];

  upsellData.forEach((data) => {
    const interval = setInterval(() => {
      const popupCR = document.querySelector("#candyrack-frame");
      const checkUpsellOffer = popupCR?.contentDocument?.querySelector(`li[data-offer-id='${data.offerId}']`);
      const selectUpsellDescContent = checkUpsellOffer?.querySelector(".Offer-Description-Content");
      const checkCustomLink = popupCR?.contentDocument?.querySelector(`#${data.buttonId}`);
      
      if (popupCR && checkUpsellOffer && selectUpsellDescContent && !checkCustomLink) {
        let newCustomLink = document.createElement("button");
        newCustomLink.id = data.buttonId;
        newCustomLink.textContent = "Customize";
        newCustomLink.addEventListener("click", (e) => {
          e.preventDefault();
          isCustomizeButtonClicked = true; // Set the flag when Customize button is clicked
          console.log("Customize button clicked");

          const parentProduct = popupCR?.contentDocument?.querySelector('[data-cy="continue-button"]');
          if (parentProduct) {
            parentProduct.click(); // Simulate clicking the "Continue" button to add the product to cart

            // Wait for the product to be added to the cart, then redirect
            waitForProductAddedAndRedirect(data.redirectLink).then(() => {
              isCustomizeButtonClicked = false; // Reset the flag after redirect
            });
          }
        });

        selectUpsellDescContent.insertAdjacentElement("afterend", newCustomLink);
        clearInterval(interval);
      }
    }, 300);
  });

  const redirectToCartPage = () => {
    if (!isCustomizeButtonClicked) {
      waitForProductAddedAndRedirect('https://visitag.com/cart');
    }
  };

  const redirectToShopAllPage = () => {
    if (!isCustomizeButtonClicked) {
      waitForProductAddedAndRedirect('https://visitag.com/collections/shop-all');
    }
  };

  const interval = setInterval(() => {
    const popupCR = document.querySelector("#candyrack-frame");
    const closeButton = popupCR?.contentDocument?.querySelector('.Close-Button');
    const noThankYouButton = popupCR?.contentDocument?.querySelector('.Button-Reject');
    const continueButton = popupCR?.contentDocument?.querySelector('.Button-Primary');

    if (closeButton && noThankYouButton && continueButton) {
      // Remove existing listeners to prevent multiple bindings
      closeButton.removeEventListener('click', redirectToCartPage);
      noThankYouButton.removeEventListener('click', redirectToCartPage);
      continueButton.removeEventListener('click', redirectToShopAllPage);

      // Add listeners for redirection only if Customize button was not clicked
      closeButton.addEventListener('click', redirectToCartPage);
      noThankYouButton.addEventListener('click', redirectToCartPage);
      continueButton.addEventListener('click', () => {
        if (!isCustomizeButtonClicked) {
          setTimeout(redirectToShopAllPage, 2500);
        }
      });
      clearInterval(interval);
    }
  }, 3000);
});